import React from "react";
import AdminManagement from "./components/templates/AdminManagement";

export default function AdminManagementPage() {
  return <AdminManagement />;
}
